import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// ใช้ path นี้สำหรับ swiper v5
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)